import animations from 'Assets/js/modules/animations';
import jsUtils from '@pernod-ricard-global-cms/jsutils';

export default function sitefooter(options = {}) {
  try {
    const { block } = options;
    jsUtils.loadCss(block.dataset.assetkey, options).then(() => {
      animations.fadeIn(block);
      // Add your Javascript code here...
      const bodyTag = document.querySelector('body');
      const marketSelector = document.querySelector('.market-selector');
      if (marketSelector) {
        const marketCurrent = marketSelector.querySelector('.market.current');
        const marketsList = marketSelector.querySelector('.markets-list');
        marketCurrent.onclick = () => marketsList.classList.toggle('open');
        bodyTag.onclick = (event) => {
          if (!event.target.parentElement.classList.contains('markets-menu')) {
            marketsList.classList.remove('open');
          }
        };
      }
    });
  } catch (error) {
    console.error(error);
  }
}
